import { ZP_CLIENT_ID, ZP_REDIRECT_URI } from 'src/components/ImportResumeModal/consts';

export const getUrl = (): string => {
    return (
        `https://hh.ru/oauth/authorize` +
        `?response_type=code&client_id=${ZP_CLIENT_ID}&redirect_uri=${ZP_REDIRECT_URI}/zp_resume_import/oauth_success&role=applicant&back_redirect=${window?.location?.origin}/close`
    );
};
